module.exports = __webpack_public_path__ + "img/SES_140320001.0ebb329c.jpg";